module.exports = __webpack_public_path__ + "static/media/check_normal.90357d8a.svg";